export function updatePreview(total, perFilter) {
    return {
        type: ACTION_UPDATE_PREVIEW,
        total,
        perFilter,
    };
}
export const ACTION_UPDATE_PREVIEW = 'QRY_ACTION_UPDATE_PREVIEW';
